import { useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "src/modules/notification";
import exportTransactionReport from "src/configs/apis/consumer-engagement/getExportTransactionReport.api";
import {
  getTransactionReport,
  resetTransactionReportSelected,
} from "../../../redux";
import TngReportDetailDialogComponent from "./tngReportDetailDialog.component";

export default function TngReportDetailDialogContainer({ date, handleClose }) {
  const dispatch = useDispatch();
  const isFetching = useSelector((state) =>
    selectLoading(state, getTransactionReport.typePrefix)
  );
  const data = useSelector((state) => state.transactionReport.record);

  useEffect(() => {
    if (date) {
      dispatch(getTransactionReport({ date }));
    }

    return () => {
      dispatch(resetTransactionReportSelected());
    };
  }, [date, dispatch]);

  const onExport = useCallback(
    async (format) => {
      try {
        const response = await exportTransactionReport({ date, format });
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Daily_Disbursement_Report_Details_${date.replace(/-/g, "")}.${format}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Export failed:", error);
      }
    },
    [date]
  );

  return (
    <>
      {(data || isFetching) && (
        <TngReportDetailDialogComponent
          handleClose={handleClose}
          isFetching={isFetching}
          data={data}
          onExport={onExport}
        />
      )}
    </>
  );
}
